import { render, staticRenderFns } from "./ItemsListProfile.vue?vue&type=template&id=48b0acfd&scoped=true&"
import script from "./ItemsListProfile.vue?vue&type=script&lang=js&"
export * from "./ItemsListProfile.vue?vue&type=script&lang=js&"
import style0 from "./ItemsListProfile.vue?vue&type=style&index=0&id=48b0acfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0acfd",
  null
  
)

export default component.exports